module.exports = __webpack_public_path__ + "static/media/accept.0d67f621.png";